<template>
  <div class="ml10" style="position: relative;">
    <ul class="top_tab clearfix mb30">
      <li class="fl" :class="{active:show=='adminList'}" @click="tabToConfig">管理员列表</li>
      <li class="fl" :class="{active:show=='adminCompany'}" @click="tabToFixed">单位信息管理</li>
    </ul>
    <adminList v-if="show=='adminList'"></adminList>
    <adminCompany v-if="show=='adminCompany'"></adminCompany>
  </div>
</template>
<script>
  import adminList from './power_set/adminList'
  import adminCompany from './power_set/adminCompany'
  export default {
    name:'powerSet',
    data () {
      return {
        show:'adminList'
      }
    },
    components:{
      'adminList': adminList,
      'adminCompany':adminCompany
    },
    methods:{
      tabToConfig:function(){
        this.show = 'adminList';
      },
      tabToFixed:function(){
        this.show = 'adminCompany';
      }
    }
  }
</script>
<style lang="less">
  .top_tab{
  li{
    height:60px;
    line-height: 60px;
    padding:0 10px;
    text-align: center;
    font-size: 18px;
    margin-right: 10px;
  }
  li:hover{
    color: #00A5FA;
  }
  li.active{
    color: #00A5FA;
    border-bottom: 2px solid #00A5FA;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/powerSet.vue